export default "__VITE_ASSET__d19070b8__"